import { Autocomplete } from 'src/components/Autocomplete';
import { Chip } from 'src/components/Chip';
import { TextField } from 'src/components/TextField';

interface StartedOrActiveSubscriptionsFilterProps {
  label: string;
  value: string[] | undefined;
  setValue: (newVal: string[]) => void;
  valueOnly?: boolean;
}

const subscriptionOptions = [
  { id: null, name: 'Started and Cancelled' },
  { id: 'started', name: 'Started Only' },
  { id: 'cancelled', name: 'Cancelled Only' },
];

export const StartedOrActiveSubscriptionsFilter: React.FC<
  StartedOrActiveSubscriptionsFilterProps
> = ({ label, value, setValue, valueOnly }) => {
  const selectedValues = value ? String(value).split(',') : [];

  if (valueOnly) {
    return selectedValues.length > 0 ? (
      <>
        {selectedValues
          .map(
            (v) =>
              subscriptionOptions.find((option) => option.id === v)?.name || ''
          )
          .join(', ')}
      </>
    ) : null;
  }

  const selectedOptions = selectedValues.map(
    (v) =>
      subscriptionOptions.find((option) => option.id === v) || {
        id: v,
        name: v,
      }
  );

  return (
    <Autocomplete
      multiple
      options={subscriptionOptions}
      getOptionLabel={(option) =>
        typeof option === 'string'
          ? subscriptionOptions.find((o) => o.id === option)?.name || option
          : option.name
      }
      value={selectedOptions}
      onChange={(_, newValue) => {
        setValue(
          newValue.map((v) => (typeof v === 'string' ? v : v.id)).join(',')
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Select Subscription Status"
        />
      )}
      renderTags={(value: readonly any[], getTagProps) =>
        value.map((option: any, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              label={typeof option === 'string' ? option : option.name}
              key={key}
              {...tagProps}
            />
          );
        })
      }
    />
  );
};
